import React from "react";
import { XCircleIcon } from "@heroicons/react/24/solid";
import EtDeleteUserReflectionComp from "@/features/userReflections/EtDeleteUserReflectionComp";

const EtModalDeleteUserReflection = ({
  showModal = false,
  onClose = () => {},
  atomicRecord = null,
  refetchUserReflections = () => {}, // future
  refetchUserReflectionsAll = () => {}
}) => {

  // First Created: 05 Dec 2025  
  // Author: Atul Pandey  
  // Purpose: Modal wrapper for deleting a user reflection

  if (!showModal) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-start font-poppins overflow-y-auto p-4"
      style={{ zIndex: 9999 }}
    >
      <div className="bg-black p-3 rounded-lg shadow-lg shadow-black relative w-full max-w-2xl">

        {/* Close Button */}
        <div
          className="absolute top-1 right-1 m-1 cursor-pointer h-7 w-7 flex justify-center items-center"
          onClick={onClose}
        >
          <XCircleIcon className="text-orange-600 hover:text-red-600 h-7 w-7" />
        </div>

        {/* Delete Component */}
        <EtDeleteUserReflectionComp
          atomicRecord={atomicRecord}
          onClose={onClose}
          refetchUserReflections={refetchUserReflections}
          refetchUserReflectionsAll={refetchUserReflectionsAll}
        />

      </div>
    </div>
  );
};

export default EtModalDeleteUserReflection;